import React, {useState} from "react";
import Blogs from "./blogs";
import Reports from "./reports";
import "./BlogsAndReports.scss";

const BlogsAndReports = () => {
  const [activeTab, setActiveTab] = useState("blogs");

  return (
    <div className="blogs-and-reports-wrapper">
      <div className="section-header">
        <div className="header-left">
          <span className="subtitle">Blogs & Reports</span>
          <h2 className="main-heading">
            Insights on Strategy, Finance & <br /> Capital Readiness
          </h2>
        </div>
        <div className="header-right">
          <div className="tab-switcher">
            <button
              className={`tab-btn ${activeTab === "reports" ? "active" : ""}`}
              onClick={() => setActiveTab("reports")}
            >
              Reports
            </button>
            <button
              className={`tab-btn ${activeTab === "blogs" ? "active" : ""}`}
              onClick={() => setActiveTab("blogs")}
            >
              Blogs
            </button>
          </div>
        </div>
      </div>
      <div className="content-area">
        {activeTab === "blogs" ? <Blogs /> : <Reports />}
      </div>
    </div>
  );
};

export default BlogsAndReports;
